import {AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, ElementRef} from "@angular/core";
import {toggleKlasseVedSticky} from "../../../direktiver/toggleKlasseVedSticky/toggleKlasseVedSticky";
import {TranslateModule} from "@ngx-translate/core";


@Component({
    selector: 'inline-skjema-handlinger',
    templateUrl: './inline-skjema-handlinger.html',
    styleUrls: ['./inline-skjema-handlinger.scss'],
    imports: [
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineSkjemaHandlingerKomponent  implements AfterViewInit {
    constructor(private el: ElementRef<HTMLElement>, private destroyRef: DestroyRef) {
    }

    ngAfterViewInit(): void {
        //init av toggleKlasseVedSticky må skje etter at barn har blitt tegnet ut slik elementet har fått sin tilnærmede størrelse
        //ellers vil ved 'er-sticky' alltid bli lagt til selvom elementet vises og ingen scrolling er nødvendig)
        toggleKlasseVedSticky(this.el.nativeElement, 'er-sticky', this.destroyRef)
    }
}
